import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import { useNavigate } from "react-router-dom";
import HeroBanner2 from "../components/HeroBanner2";
import Loader from "../components/Loader";
export default function Shop() {
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [subCategoryData, setsubCategoryData] = useState([]);
    const [sizeData, setSizeData] = useState([]);
    const [ageData, setAgeData] = useState([]);
    const [productData, setProductData] = useState([]);
    const [selectedSize, setSelectedSize] = useState(null);
    const [selectedId, setSelectedId] = useState(null);
    const [selectedSubCategoryId, setSelectedSubCategoryId] = useState(null);
    const [selectedAgeId, setSelectedAgeId] = useState("");
    const [selectedAge, setSelectedAge] = useState("");
    const navigate = useNavigate();
    useEffect(() => {
        fetchCategoryData();
        fetchAllProductData();
    }, []);
    useEffect(() => {
        if (dataSource?.length > 0) {
            const storedId = localStorage.getItem("selectedCategoryId");
            if (storedId) {
                setSelectedId(String(storedId));
            }
        }
    }, [dataSource]);
    const fetchCategoryData = async () => {
        setLoading(true);
        try {
            const [cat, sub, size, age] = await Promise.all([
                makeRequest("get", webEndPoint + "maincategories"),
                makeRequest("get", webEndPoint + "subcategories/bycategory/" + localStorage.getItem("selectedCategoryId")),
                // makeRequest("get", webEndPoint + "sizes"),
                // makeRequest("get", webEndPoint + "ages"),
            ]);
            setDataSource(cat?.data || []);
            setsubCategoryData(sub?.data || []);
            // setSizeData(size?.data || []);
            // setAgeData(age?.data || []);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const fetchAllProductData = async (categoryId = localStorage.getItem("selectedCategoryId"), subCategoryId = null, ageId = "") => {
        setLoading(true);
        try {
            const params = new URLSearchParams();
            params.append("main_category_id", categoryId);
            if (subCategoryId) {
                params.append("sub_category_id", subCategoryId);
            }
            if (ageId) {
                params.append("age_id", ageId);
            }
            const response = await makeRequest(
                "get",
                `${webEndPoint}product/filter?${params.toString()}`
            );
            setProductData(response?.data || []);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const handleCategoryClick = (id) => {
        navigate(`/shop/productdetails/${id}`);
    };
    const ageFilters = [...new Set(
        productData.flatMap(product => {
            const desc = product.product_description || "";
            const matches = desc.match(/\d+\s*-\s*\d+/g);
            return matches
                ? matches.map(age => age.replace(/\s+/g, ""))
                : [];
        })
    )].sort((a, b) => parseInt(a) - parseInt(b));
    const filteredProducts = productData.filter(product => {
        if (!selectedAge) return true;
        const desc = product.product_description || "";
        return desc.includes(selectedAge);
    });
    return (
        <div>
            <Loader loading={loading} />
            <Header />
            <HeroBanner2 />
            <div className="category-containers">
                {dataSource?.map((item, index) => (
                    <div key={index}
                        className={`category-card ${String(selectedId) === String(item.rfId) ? "active" : ""}`}
                        onClick={() => {
                            const isSame = String(selectedId) === String(item.rfId);
                            const newId = isSame ? null : String(item.rfId);
                            setSelectedId(newId);
                            if (newId) {
                                localStorage.setItem("selectedCategoryId", newId);
                                fetchCategoryData();
                                fetchAllProductData();
                            } else {
                                localStorage.removeItem("selectedCategoryId");
                            }
                        }}>
                        <img src={item?.image_url} alt={item?.maincategory_name} />
                        <span>{item.maincategory_name}</span>
                    </div>
                ))}
            </div>
            <div className="shop-layout">
                <aside className="filter">
                    <h3>Filters</h3>
                    <div className="filter-body">
                        <div className="filter-group">
                            <p>Sub Category</p>
                            {subCategoryData?.map((item, index) => (
                                <div key={index}>
                                    <label className="custom-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={selectedSubCategoryId === item.subcategory_id}
                                            onChange={() => {
                                                const isSame = selectedSubCategoryId === item.subcategory_id;
                                                const newId = isSame ? null : item.subcategory_id;
                                                setSelectedSubCategoryId(newId);
                                                // fetchAllProductData(newId, selectedAgeId);
                                                fetchAllProductData(
                                                    localStorage.getItem("selectedCategoryId"),
                                                    newId,
                                                    selectedAge
                                                );
                                            }}
                                        />
                                        <span className="checkmark"></span>
                                        {item.subcategory_name}
                                    </label>
                                </div>
                            ))}
                        </div>
                        <div className="filter-group">
                            <p>Age</p>

                            {ageFilters.map((age) => (
                                <div key={age}>
                                    <label className="custom-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={selectedAge === age}
                                            onChange={() => {
                                                setSelectedAge(selectedAge === age ? "" : age);
                                            }}
                                        />
                                        <span className="checkmark"></span>
                                        {age} Years
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>
                    {/* <div className="filter-group">
                        <p>Age</p>
                        <select
                            className="form-select"
                            value={selectedAgeId}
                            onChange={(e) => {
                                const ageId = e.target.value;
                                setSelectedAgeId(ageId);
                                fetchAllProductData(selectedSubCategoryId, ageId);
                            }}>
                            <option value="">Select Age</option>
                            {ageData?.map((item) => (
                                <option key={item.rfId} value={item.rfId}>
                                    {item.age_name}
                                </option>
                            ))}
                        </select>
                    </div> */}
                </aside>
                <section className="product">
                    {/* {productData?.map((p) => (
                        <div key={p.id} className="prod-card" onClick={() => handleCategoryClick(p?.rfId)} style={{ cursor: "pointer" }}>
                            <img src={p?.product_main_image} alt={p?.product_name} />
                            <h4>{p?.product_name}</h4>
                            <div className="rating">⭐⭐⭐⭐⭐</div>
                        </div>
                    ))} */}
                    {filteredProducts?.length > 0 ? (
                        filteredProducts.map((p) => (
                            <div key={p.id} className="prod-card" onClick={() => handleCategoryClick(p?.rfId)} style={{ cursor: "pointer" }}>
                                <img src={p?.product_main_image} alt={p?.product_name} />
                                <h4>{p?.product_name}</h4>
                                <div className="rating">⭐⭐⭐⭐⭐</div>
                            </div>
                        ))
                    ) : (
                        <div className="out-of-stock">
                            <h3>No Stock Available. Will restock soon</h3>
                            <p>No products found for the selected category, subcategory, or age.</p>
                        </div>
                    )}
                </section>
            </div>
            <Footer />
        </div>
    )
}
